<template>
<div class="container">
    <div class="row">
        <template v-if="showSubmit(viewName)">
            <div class="col-12 tip pt-1">
                <div class="row px-sm-3 footer-row">
                    <div class="col flex-row-reverse d-flex offset-6">
                        <button type="button" @click="gotoThankYou()" class="fw-bold m-1 btn btn-viskase-white-slim font-size-xs-6">
                            <span>{{submit}} <i class="bi-caret-right-fill" role="img" aria-label="Caret right fill"></i></span>
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="showOurRecommendation(viewName)">
            <div class="col-12 tip pt-1">
                <div class="row px-sm-3 footer-row">
                    <div class="col">
                        <div><img class="float-start p-2 p-md-3" src="assets/img/white_bulb.png" /></div>
                        <div class="h4 h4-slim fw-bold">{{ourRecommendation}}</div>
                        <div class="footer-tip">{{selectedCasing.tip}}</div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="showOfferRequest(viewName)">
            <div class="col-12 tip pt-1">
                <div class="row px-sm-3 footer-row">
                    <div class="col flex-row-reverse d-flex">
                        <span class="fw-bold me-2"> {{whatWouldYouLikeToNext}}</span>
                    </div>
                </div>
                <div class="row px-sm-3 footer-row">
                    <div class="col flex-row-reverse d-flex">
                        <button type="button" @click="gotoMeeting()" class="fw-bold m-1 btn btn-viskase-white-slim font-size-xs-6">
                            <span> {{speakWithProductManager}} <i class="bi-caret-right-fill" role="img" aria-label="Caret right fill"></i></span>
                        </button>
                        <button type="button" @click="gotoOfferRequest()" class="fw-bold m-1 btn btn-viskase-white-slim font-size-xs-6">
                            <span>{{requestAnOffer}} <i class="bi-caret-right-fill" role="img" aria-label="Caret right fill"></i></span>
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </div>
</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { mapProperties } from "@/utilities/vuex";
import axios from "axios";
export default {
  name: "ViskaseAppFooter",
  props: {},
  computed: {
    ...mapState([
      "selectedCasing",
      "selectedLanguage",
      "selectedProduct",
      "selectedSolution",
      "offerCasings",
      "cards",
    ]),
    ...mapGetters(["showSubmit", "showOfferRequest", "showOurRecommendation"]),
    ...mapProperties(["offerName", "offerPhone", "offerCompany", "offerEmail"]),
    viewName() {
      return this.$route.name;
    },
    ourRecommendation() {
      return this.cards.footer.our_recommendation;
    },
    requestAnOffer() {
      return this.cards.footer.request_an_offer;
    },
    submit() {
      return this.cards.footer.submit;
    },
    speakWithProductManager() {
      return this.cards.footer.speak_with_product_manager;
    },
    whatWouldYouLikeToNext() {
      return this.cards.footer.what_would_you_like_to_next;
    },
  },
  methods: {
    gotoOfferRequest() {
      this.$router.push({
        name: "offer-request",
        params: {
          language: this.selectedLanguage.name,
          product: this.selectedProduct.name,
          solution: this.selectedSolution.name,
          casing: this.selectedCasing.name,
        },
      });
    },
    gotoMeeting() {
      this.$router.push({
        name: "meeting",
        params: {
          language: this.selectedLanguage.name,
          product: this.selectedProduct.name,
          solution: this.selectedSolution.name,
          casing: this.selectedCasing.name,
        },
      });
    },
    gotoThankYou() {
      debugger;
      var payload = {
        selection: this.offerCasings
          .filter((x) => x.selected === true)
          .map((x) => x.name),
        email: this.offerEmail,
        name: this.offerName,
        company: this.offerCompany,
        phone: this.offerPhone,
        agreeAll: this.agreeAll,
        agreeProcessing: this.agreeProcessing,
        agreePhone: this.agreePhone,
        agreeEmail: this.agreeEmail,
      };
      axios.post(window.__env.api.api_url + "/email", payload).then((res) => {
        for (const element of this.offerCasings) {
          if (element.name === this.selectedCasing.name) {
            element.selected = false;
          }
        }
        this.offerName = "";
        this.offerCompany = "";
        this.offerEmail = "";
        this.offerPhone = "";
        this.agreeAll = false;
        this.agreeProcessing = false;
        this.agreePhone = false;
        this.agreeEmail = false;
      });
      this.$router.push({
        name: "thank-you",
        params: {
          language: this.selectedLanguage.name,
          product: this.selectedProduct.name,
          solution: this.selectedSolution.name,
          casing: this.selectedCasing.name,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.h4-slim {
  margin-bottom: 0.2rem;
}

@media (min-width: 0px) {
  .footer-tip {
    font-size: 0.65rem;
  }
}

@media (min-width: 768px) {
  .footer-tip {
    font-size: 1rem;
  }
}
</style>
